import React from "react";
import { number, string } from "prop-types";
import { useLocale } from "@insightfulscience/i18";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";

const SelectSeatsMessage = ({ seats, originSeats, textAlign = "center", ...props }) => {
	const [t] = useLocale("select-seats");
	return seats !== originSeats ? (
		<Paragraph
			sx={{ fontSize: "s", textAlign, fontColor: "green" }}
			spacing={{ mt: 2, mb: 2 }}
			{...props}
		>
			{t("DISCOUNTS", { seats, originSeats })}
		</Paragraph>
	) : null;
};

SelectSeatsMessage.propTypes = {
	seats: number.isRequired,
	originSeats: number.isRequired,
	textAlign: string,
};
export default SelectSeatsMessage;
